import React, { useMemo, useRef, useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Card,
  CardContent,
  CardMedia,
  Typography,
  FormControl,
  Button,
  CircularProgress,
  Modal,
  Backdrop,
  Fade,
  Grid,
  InputLabel,
} from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { isValid } from 'date-fns';
import InputMask from 'react-input-mask';
import { optionStyles } from './styles';
import api from '../../services/api';
import Add from '../../assets/add.svg';
import Remove from '../../assets/remove.svg';
import Success from '../../assets/Success.svg';
import {
  OMS1Type,
  ResponseOMS1Type,
  OMS2Type,
  FatoresDeRiscoType,
  ResponseGoalType,
  GoalType,
  ResponseOMS2Type,
  ResponseFatoresDeRiscoType,
  ResponseManagement,
} from '../../@types/managementTypes';
import { toISOLocal } from '../../utils/formatDate';
import ShowSnackbar, { SetSnackbarType } from '../../components/SnackBar';
import { sortMonthYear } from './utils';
import Colors from '../../components/Colors';
import {
  getManagementsDates,
  updateManagementsDates,
} from '../../actions/managementActions';

const Management: React.FC = () => {
  const classes = optionStyles();

  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const yearMeta = useRef<HTMLInputElement>(null);
  const goalMeta = useRef<HTMLInputElement>(null);

  const yearOMS1 = useRef<HTMLInputElement>(null);
  const qtdMortosPorQtdVeiculos = useRef<HTMLInputElement>(null);
  const qtdMortosPorQtdMotos = useRef<HTMLInputElement>(null);

  const yearOMS2 = useRef<HTMLInputElement>(null);
  const qtdMortosPorPopulacao = useRef<HTMLInputElement>(null);

  const mesAnoCapacete = useRef<HTMLInputElement>(null);
  const todosOcupantesUsandoCapacete = useRef<HTMLInputElement>(null);
  const todosOcupantesUsandoCapaceteCorretamente = useRef<HTMLInputElement>(null);

  const mesAnoCinto1 = useRef<HTMLInputElement>(null);
  const todosOcupantes = useRef<HTMLInputElement>(null);
  const condutores = useRef<HTMLInputElement>(null);

  const mesAnoCinto2 = useRef<HTMLInputElement>(null);
  const bancoDianteiro = useRef<HTMLInputElement>(null);
  const bancoTraseiro = useRef<HTMLInputElement>(null);

  const mesAnoDispRetCri = useRef<HTMLInputElement>(null);
  const crianca = useRef<HTMLInputElement>(null);
  const criancaPeq = useRef<HTMLInputElement>(null);

  const mesAnoVelocidade = useRef<HTMLInputElement>(null);
  const condutoresGeral = useRef<HTMLInputElement>(null);
  const motociclistas = useRef<HTMLInputElement>(null);

  const mesAnoAlcool = useRef<HTMLInputElement>(null);
  const positivosRecusas = useRef<HTMLInputElement>(null);
  const positivos = useRef<HTMLInputElement>(null);

  const mesAnoCelular = useRef<HTMLInputElement>(null);
  const digitando = useRef<HTMLInputElement>(null);
  const falando = useRef<HTMLInputElement>(null);

  const [add, setAdd] = useState<boolean>(false);
  const [remove, setRemove] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [anoKey, setAnoKey] = useState<string>();
  const [meta, setMeta] = useState<boolean>(false);
  const [oms1, setOMS1] = useState<boolean>(false);
  const [oms2, setOMS2] = useState<boolean>(false);
  const [oms1List, setOMS1List] = useState<OMS1Type[]>([]);
  const [oms2List, setOMS2List] = useState<OMS2Type[]>([]);

  const [usoCapacete, setUsoCapacete] = useState<boolean>(false);
  const [usoCapaceteList, setUsoCapaceteList] = useState<FatoresDeRiscoType[]>([]);

  const [usoCinto1, setUsoCinto1] = useState<boolean>(false);
  const [usoCinto1List, setUsoCinto1List] = useState<FatoresDeRiscoType[]>([]);

  const [usoCinto2, setUsoCinto2] = useState<boolean>(false);
  const [usoCinto2List, setUsoCinto2List] = useState<FatoresDeRiscoType[]>([]);

  const [usoDispRetCrianca, setUsoDispRetCrianca] = useState<boolean>(false);
  const [usoDispRetCriancaList, setUsoDispRetCriancaList] = useState<
    FatoresDeRiscoType[]
  >([]);

  const [velocidade, setVelocidade] = useState<boolean>(false);
  const [velocidadeList, setVelocidadeList] = useState<FatoresDeRiscoType[]>([]);

  const [usoAlcool, setUsoAlcool] = useState<boolean>(false);
  const [usoAlcoolList, setUsoAlcoolList] = useState<FatoresDeRiscoType[]>([]);

  const [usoCelular, setUsoCelular] = useState<boolean>(false);
  const [usoCelularList, setUsoCelularList] = useState<FatoresDeRiscoType[]>([]);

  const [goal, setGoal] = useState<GoalType[]>([]);
  const [openError, setOpenError] = React.useState(false);
  const [openSuccess, setSuccess] = React.useState(false);

  const handleCloseError = () => {
    setOpenError(false);
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
    window.location.reload();
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleSetFalse = () => {
    setOMS1(false);
    setMeta(false);
    setOMS2(false);
    setAdd(false);
    setEdit(false);
    setRemove(false);
    setOpenError(false);
    setSuccess(false);
    setOpenModal(false);
    setUsoCapacete(false);
    setUsoCinto1(false);
    setUsoCinto2(false);
    setUsoDispRetCrianca(false);
    setVelocidade(false);
    setUsoAlcool(false);
    setUsoCelular(false);
  };

  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [mapStartDate, setMapStartDate] = useState<string>('');
  const [mapEndDate, setMapEndDate] = useState<string>('');
  const [panelStartDate, setPanelStartDate] = useState<string>('');
  const [panelEndDate, setPanelEndDate] = useState<string>('');
  const [generalDate, setGeneralDate] = useState<string>('');
  const [fatalDate, setFatalDate] = useState<string>('');
  const [samuStartDate, setSamuStartDate] = useState<string>('');
  const [samuEndDate, setSamuEndDate] = useState<string>('');
  const [snackBar, setSnackbar] = useState<SetSnackbarType>({ open: false, message: '' });

  const handleDateChange = (
    key:
      | 'mapStartDateSetter'
      | 'mapEndDateSetter'
      | 'panelStartDateSetter'
      | 'panelEndDateSetter'
      | 'fatalDateSetter'
      | 'generalDateSetter',
    value: Date | null,
  ) => {
    const setter = {
      mapStartDateSetter: (dateValue: Date) => {
        setMapStartDate(toISOLocal(dateValue));
      },
      mapEndDateSetter: (dateValue: Date) => {
        dateValue.setHours(23);
        dateValue.setMinutes(59);
        dateValue.setSeconds(59);
        setMapEndDate(toISOLocal(dateValue));
      },
      panelStartDateSetter: (dateValue: Date) => {
        setPanelStartDate(toISOLocal(dateValue));
      },
      panelEndDateSetter: (dateValue: Date) => {
        dateValue.setHours(23);
        dateValue.setMinutes(59);
        dateValue.setSeconds(59);
        setPanelEndDate(toISOLocal(dateValue));
      },

      generalDateSetter: (dateValue: Date) => {
        setGeneralDate(toISOLocal(dateValue));
      },
      fatalDateSetter: (dateValue: Date) => {
        dateValue.setHours(0);
        dateValue.setMinutes(0);
        dateValue.setSeconds(0);
        setFatalDate(toISOLocal(dateValue));
        console.log(toISOLocal(dateValue));
      },
    };

    if (value && isValid(new Date(value))) {
      setter[key](value);
    }
  };

  const fetchDatas = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await getManagementsDates();
      setMapStartDate(data.datetime_map_begin);
      setMapEndDate(data.datetime_map_end);
      setPanelStartDate(data.datetime_begin);
      setPanelEndDate(data.datetime_end);
      setFatalDate(data.datetime_fatal);
      setGeneralDate(data.datetime_general);
    } catch (error) {
      setSnackbar({
        open: true,
        message:
          'Erro ao estabelecer conexão. Tente novamente dentro de alguns instantes.',
      });
    } finally {
      setLoading(false);
    }
  }, [authHeader]);

  const fetchGoal = useCallback(async () => {
    const { data } = await api.get<ResponseGoalType>(`/api/goal/`, {
      headers: {
        ...authHeader,
      },
    });

    setGoal(data.results);
  }, [authHeader]);

  const fetchOMS1 = useCallback(async () => {
    const { data } = await api.get<ResponseOMS1Type>('/api/oms1/?limit=100', {
      headers: {
        ...authHeader,
      },
    });
    let values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        year: item.year,
        qtdMortosPorQtdVeiculos: item.qtdMortosPorQtdVeiculos,
        qtdMortosPorQtdMotos: item.qtdMortosPorQtdMotos,
      };
    });

    values = values.sort((a: any, b: any) => {
      return a.year < b.year ? 1 : b.year < a.year ? -1 : 0;
    });
    setOMS1List(values);
  }, [authHeader]);

  const fetchOMS2 = useCallback(async () => {
    const { data } = await api.get<ResponseOMS2Type>('/api/oms2/?limit=100', {
      headers: {
        ...authHeader,
      },
    });
    let values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        year: item.year,
        qtdMortosPorPopulacao: item.qtdMortosPorPopulacao,
      };
    });

    values = values.sort((a: any, b: any) => {
      return a.year < b.year ? 1 : b.year < a.year ? -1 : 0;
    });

    setOMS2List(values);
  }, [authHeader]);

  const fetchUsoDoCapacete = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/uso_do_capacete/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoCapaceteList(sortMonthYear(values));
  }, [authHeader]);

  const fetchUsoDoCinto1 = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/uso_do_cinto/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoCinto1List(sortMonthYear(values));
  }, [authHeader]);

  const fetchUsoDoCinto2 = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/uso_do_cinto2/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoCinto2List(sortMonthYear(values));
  }, [authHeader]);

  const fetchUsoDispRetCri = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/uso_disp_ret_criancas/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoDispRetCriancaList(sortMonthYear(values));
  }, [authHeader]);

  const fetchVelocidade = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/velocidade/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setVelocidadeList(sortMonthYear(values));
  }, [authHeader]);

  const fetchUsoAlcool = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/dir_influencia_alcool/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );
    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoAlcoolList(sortMonthYear(values));
  }, [authHeader]);

  const fetchUsoCelular = useCallback(async () => {
    const { data } = await api.get<ResponseFatoresDeRiscoType>(
      '/api/fatores_de_risco/uso_do_celular/?limit=1000',
      {
        headers: {
          ...authHeader,
        },
      },
    );

    const values = data.results.map((item) => {
      return {
        uuid: item.uuid,
        mes_ano: item.mes_ano,
        line1: item.line1,
        line2: item.line2,
      };
    });

    setUsoCelularList(sortMonthYear(values));
  }, [authHeader]);

  useEffect(() => {
    fetchDatas();
    fetchGoal();
    fetchOMS1();
    fetchOMS2();
    fetchUsoDoCapacete();
    fetchUsoDoCinto1();
    fetchUsoDoCinto2();
    fetchUsoDispRetCri();
    fetchVelocidade();
    fetchUsoAlcool();
    fetchUsoCelular();
  }, [
    fetchDatas,
    fetchOMS1,
    fetchOMS2,
    fetchGoal,
    fetchUsoDoCapacete,
    fetchUsoDoCinto1,
    fetchUsoDoCinto2,
    fetchUsoDispRetCri,
    fetchVelocidade,
    fetchUsoAlcool,
    fetchUsoCelular,
  ]);

  useEffect(() => {
    const currentDate = new Date();
    setSamuStartDate(toISOLocal(new Date(currentDate.getFullYear(), 0, 1))); // Primeira data do ano
    setSamuEndDate(toISOLocal(currentDate)); // Data atual
  }, []);

  const postDate = async () => {
    setLoading(true);
    try {
      const data = {
        datetime_begin: panelStartDate,
        datetime_end: panelEndDate,
        datetime_map_begin: mapStartDate,
        datetime_map_end: mapEndDate,
        datetime_fatal: fatalDate,
        datetime_general: generalDate,
      };
      const response = await updateManagementsDates(data);
      setSnackbar({ open: true, message: 'Datas atualizadas com sucesso!' });
      setMapStartDate(response.data.datetime_map_begin);
      setMapEndDate(response.data.datetime_map_end);
      setPanelStartDate(response.data.datetime_begin);
      setPanelEndDate(response.data.datetime_end);
      setFatalDate(response.data.datetime_fatal);
      setGeneralDate(response.data.datetime_general);
    } catch (error) {
      setOpenError(true);
      setSnackbar({
        open: true,
        message:
          'Erro ao atualizar as datas. Tente novamente dentro de alguns instantes.',
      });
    } finally {
      setLoading(false);
    }
  };

  const transferSamuToIncident = async () => {
    setLoading(true);
    console.log(samuStartDate);
    console.log(samuEndDate);

    if (new Date(samuStartDate) <= new Date(samuEndDate)) {
      console.log('As datas são válidas');

      await api
        .put(`/api/samu_records/transfer_to_incident/`, null, {
          headers: authHeader,
          params: {
            occurred_min: samuStartDate,
            occurred_max: samuEndDate,
          },
        })
        .then((response) => {
          setLoading(false);
          if (response.status === 200) {
            setSnackbar({ open: true, message: response.data });
          }
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });

      //setLoading(true);
      // console.log(data);
    } else {
      console.log('As datas não são válidas');
      setOpenError(true);
    }
    setLoading(false);
  };

  const handleAddMeta = async () => {
    if (yearMeta.current && goalMeta.current) {
      setLoading(true);
      const data = {
        related_year: Number(yearMeta.current.value),
        goal_value: Number(goalMeta.current.value),
        id_management: `${process.env.REACT_APP_MANAGEMENT_RECORD_ID}`,
      };
      await api
        .post(`/api/goal/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    } else {
      setOpenError(true);
    }
  };

  const handlePutGoal = async (id: string) => {
    if (yearMeta.current && goalMeta.current) {
      setLoading(true);
      const data = {
        related_year: Number(yearMeta.current.value),
        goal_value: Number(goalMeta.current.value),
        id_management: `${process.env.REACT_APP_MANAGEMENT_RECORD_ID}`,
      };
      await api
        .put(`/api/goal/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveMeta = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/goal/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleAddOMS1 = async () => {
    if (
      yearOMS1.current &&
      qtdMortosPorQtdVeiculos.current &&
      qtdMortosPorQtdMotos.current
    ) {
      setLoading(true);
      const data = {
        year: String(yearOMS1.current.value),
        qtdMortosPorQtdVeiculos: Number(qtdMortosPorQtdVeiculos.current.value).toFixed(2),
        qtdMortosPorQtdMotos: Number(qtdMortosPorQtdMotos.current.value).toFixed(2),
      };
      await api
        .post(`/api/oms1/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutOMS1 = async (id: string) => {
    if (
      yearOMS1.current &&
      qtdMortosPorQtdVeiculos.current &&
      qtdMortosPorQtdMotos.current
    ) {
      setLoading(true);
      const data = {
        year: String(yearOMS1.current.value),
        qtdMortosPorQtdVeiculos: Number(qtdMortosPorQtdVeiculos.current.value),
        qtdMortosPorQtdMotos: Number(qtdMortosPorQtdMotos.current.value),
      };
      await api
        .put(`/api/oms1/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveOMS1 = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/oms1/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleAddOMS2 = async () => {
    if (yearOMS2.current && qtdMortosPorPopulacao.current) {
      setLoading(true);
      const data = {
        year: Number(yearOMS2.current.value),
        qtdMortosPorPopulacao: Number(qtdMortosPorPopulacao.current.value).toFixed(2),
      };
      await api
        .post(`/api/oms2/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutOMS2 = async (id: string) => {
    if (yearOMS2.current && qtdMortosPorPopulacao.current) {
      setLoading(true);
      const data = {
        year: Number(yearOMS2.current.value),
        qtdMortosPorPopulacao: Number(qtdMortosPorPopulacao.current.value),
      };
      await api
        .put(`/api/oms2/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveOMS2 = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/oms2/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleAddUsoCapacete = async () => {
    if (
      mesAnoCapacete.current &&
      todosOcupantesUsandoCapacete.current &&
      todosOcupantesUsandoCapaceteCorretamente.current
    ) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCapacete.current.value),
        line1: Number(todosOcupantesUsandoCapacete.current.value),
        line2: Number(todosOcupantesUsandoCapaceteCorretamente.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/uso_do_capacete/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoCapacete = async (id: string) => {
    if (
      mesAnoCapacete.current &&
      todosOcupantesUsandoCapacete.current &&
      todosOcupantesUsandoCapaceteCorretamente.current
    ) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCapacete.current.value),
        line1: Number(todosOcupantesUsandoCapacete.current.value),
        line2: Number(todosOcupantesUsandoCapaceteCorretamente.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/uso_do_capacete/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveUsoCapacete = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/uso_do_capacete/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleAddCinto1 = async () => {
    if (mesAnoCinto1.current && todosOcupantes.current && condutores.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCinto1.current.value),
        line1: Number(todosOcupantes.current.value),
        line2: Number(condutores.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/uso_do_cinto/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleAddCinto2 = async () => {
    if (mesAnoCinto2.current && bancoDianteiro.current && bancoTraseiro.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCinto2.current.value),
        line1: Number(bancoDianteiro.current.value),
        line2: Number(bancoTraseiro.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/uso_do_cinto2/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoCinto1 = async (id: string) => {
    if (mesAnoCinto1.current && todosOcupantes.current && condutores.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCinto1.current.value),
        line1: Number(todosOcupantes.current.value),
        line2: Number(condutores.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/uso_do_cinto/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoCinto2 = async (id: string) => {
    if (mesAnoCinto2.current && bancoDianteiro.current && bancoTraseiro.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCinto2.current.value),
        line1: Number(bancoDianteiro.current.value),
        line2: Number(bancoTraseiro.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/uso_do_cinto2/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveCinto1 = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/uso_do_cinto/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleRemoveCinto2 = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/uso_do_cinto2/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleAddUsoDisRetCri = async () => {
    if (mesAnoDispRetCri.current && crianca.current && criancaPeq.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoDispRetCri.current.value),
        line1: Number(crianca.current.value),
        line2: Number(criancaPeq.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/uso_disp_ret_criancas/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleAddVelocidade = async () => {
    if (mesAnoVelocidade.current && condutoresGeral.current && motociclistas.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoVelocidade.current.value),
        line1: Number(condutoresGeral.current.value),
        line2: Number(motociclistas.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/velocidade/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleAddUsoAlcool = async () => {
    if (mesAnoAlcool.current && positivosRecusas.current && positivos.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoAlcool.current.value),
        line1: Number(positivosRecusas.current.value),
        line2: Number(positivos.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/dir_influencia_alcool/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleAddUsoCelular = async () => {
    if (mesAnoCelular.current && digitando.current && falando.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCelular.current.value),
        line1: Number(digitando.current.value),
        line2: Number(falando.current.value),
      };
      await api
        .post(`/api/fatores_de_risco/uso_do_celular/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoDispRetCri = async (id: string) => {
    if (mesAnoDispRetCri.current && crianca.current && criancaPeq.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoDispRetCri.current.value),
        line1: Number(crianca.current.value),
        line2: Number(criancaPeq.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/uso_disp_ret_criancas/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutVelocidade = async (id: string) => {
    if (mesAnoVelocidade.current && condutoresGeral.current && motociclistas.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoVelocidade.current.value),
        line1: Number(condutoresGeral.current.value),
        line2: Number(motociclistas.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/velocidade/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoAlcool = async (id: string) => {
    if (mesAnoAlcool.current && positivosRecusas.current && positivos.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoAlcool.current.value),
        line1: Number(positivosRecusas.current.value),
        line2: Number(positivos.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/dir_influencia_alcool/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handlePutUsoCelular = async (id: string) => {
    if (mesAnoCelular.current && digitando.current && falando.current) {
      setLoading(true);
      const data = {
        mes_ano: String(mesAnoCelular.current.value),
        line1: Number(digitando.current.value),
        line2: Number(falando.current.value),
      };
      await api
        .put(`/api/fatores_de_risco/uso_do_celular/${id}/`, data, {
          headers: authHeader,
        })
        .then(() => {
          setLoading(false);
          setSuccess(true);
        })
        .catch(() => {
          setLoading(false);
          setOpenError(true);
        });
    }
  };

  const handleRemoveUsoDispRetCri = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/uso_disp_ret_criancas/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleRemoveVelocidade = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/velocidade/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleRemoveUsoAlcool = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/dir_influencia_alcool/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const handleRemoveCelular = async (id: string) => {
    setLoading(true);
    await api
      .delete(`/api/fatores_de_risco/uso_do_celular/${id}/`, {
        headers: authHeader,
      })
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch(() => {
        setLoading(false);
        setOpenError(true);
      });
  };

  const modal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <div className={classes.paper}>
            {meta && remove && (
              <>
                {goal &&
                  goal.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá a meta selecionada. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveMeta(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}
            {meta && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>Definir Metas</Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Ano
                        </Typography>
                        <input
                          type="number"
                          placeholder="Ano"
                          className={classes.selectField}
                          ref={yearMeta}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Meta
                        </Typography>
                        <input
                          type="number"
                          placeholder="Meta"
                          className={classes.selectField}
                          ref={goalMeta}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddMeta();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {meta && edit && (
              <CardContent className={classes.cardContent}>
                {goal &&
                  goal.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card key={item.uuid} className={classes.rootCardModal}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Editar Metas
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexFlow: 'row',
                                    width: '90%',
                                    alignItems: 'center',
                                    justifyContent: 'space-around',
                                  }}
                                >
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Ano
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.related_year}
                                      placeholder="Ano"
                                      className={classes.selectField}
                                      ref={yearMeta}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Meta
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.goal_value}
                                      placeholder="Meta"
                                      className={classes.selectField}
                                      ref={goalMeta}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutGoal(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}
            {oms1 && remove && (
              <>
                {oms1List &&
                  oms1List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá a OMS1 selecionada. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveOMS1(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}
            {oms1 && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>Definir OMS1</Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Ano
                        </Typography>
                        <input
                          type="number"
                          placeholder="Ano"
                          className={classes.selectField}
                          ref={yearOMS1}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mortos/Veículos
                        </Typography>
                        <input
                          type="number"
                          placeholder=""
                          className={classes.selectField}
                          ref={qtdMortosPorQtdVeiculos}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mortos/Motos
                        </Typography>
                        <input
                          type="number"
                          placeholder=""
                          className={classes.selectField}
                          ref={qtdMortosPorQtdMotos}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddOMS1();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {oms1 && edit && (
              <CardContent className={classes.cardContent}>
                {oms1List &&
                  oms1List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Editar OMS1
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Ano
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.year}
                                      placeholder="Ano"
                                      className={classes.selectField}
                                      ref={yearOMS1}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mortos/Veículos
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.qtdMortosPorQtdVeiculos.toFixed(
                                        2,
                                      )}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={qtdMortosPorQtdVeiculos}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mortos/Motos
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.qtdMortosPorQtdMotos.toFixed(2)}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={qtdMortosPorQtdMotos}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutOMS1(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}
            {oms2 && remove && (
              <>
                {oms2List &&
                  oms2List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá a OMS2 selecionada. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveOMS2(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}
            {oms2 && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>Definir OMS2</Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Ano
                        </Typography>
                        <input
                          type="number"
                          placeholder="Ano"
                          className={classes.selectField}
                          ref={yearOMS2}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mortos/População
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={qtdMortosPorPopulacao}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddOMS2();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {oms2 && edit && (
              <CardContent className={classes.cardContent}>
                {oms2List &&
                  oms2List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Editar OMS1
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Ano
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.year}
                                      placeholder="Ano"
                                      className={classes.selectField}
                                      ref={yearOMS2}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mortos/População
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.qtdMortosPorPopulacao}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={qtdMortosPorPopulacao}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutOMS2(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoCapacete && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Todos usando Capacete
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoCapacete}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoCapacete}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Usando
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={todosOcupantesUsandoCapacete}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Usando corretamente
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={todosOcupantesUsandoCapaceteCorretamente}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddUsoCapacete();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}

            {usoCapacete && edit && (
              <CardContent className={classes.cardContent}>
                {usoCapaceteList &&
                  usoCapaceteList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Todos usando capacete
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoCapacete}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoCapacete}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Usando
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={todosOcupantesUsandoCapacete}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Usando corretamente
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={todosOcupantesUsandoCapaceteCorretamente}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoCapacete(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoCapacete && remove && (
              <>
                {usoCapaceteList &&
                  usoCapaceteList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveUsoCapacete(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {usoCinto1 && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Passageiros/condutores usando cinto de segurança
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoCinto1}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoCinto1}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Todos os ocupantes
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={todosOcupantes}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Condutores
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={condutores}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddCinto1();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}

            {usoCinto2 && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Passageiros utilizando cinto de segurança
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoCinto2}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoCinto2}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          No banco dianteiro
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={bancoDianteiro}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          No banco traseiro
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={bancoTraseiro}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddCinto2();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}

            {usoCinto1 && edit && (
              <CardContent className={classes.cardContent}>
                {usoCinto1List &&
                  usoCinto1List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Passageiros utilizando o cinto de segurança
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoCinto1}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoCinto1}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Todos os ocupantes
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={todosOcupantes}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Condutores
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={condutores}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoCinto1(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoCinto2 && edit && (
              <CardContent className={classes.cardContent}>
                {usoCinto2List &&
                  usoCinto2List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Passageiros utilizando o cinto de segurança
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoCinto2}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoCinto2}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Banco dianteiro
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={bancoDianteiro}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Banco traseiro
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={bancoTraseiro}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoCinto2(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoCinto1 && remove && (
              <>
                {usoCinto1List &&
                  usoCinto1List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveCinto1(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {usoCinto2 && remove && (
              <>
                {usoCinto2List &&
                  usoCinto2List.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveCinto2(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {usoDispRetCrianca && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Uso do dispositivo de retenção de crianças
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoDispRetCri}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoDispRetCri}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Crianças
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={crianca}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Crianças pequenas
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={criancaPeq}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddUsoDisRetCri();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}

            {/* VELOCIDADE */}
            {velocidade && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>Velocidade</Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoVelocidade}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoVelocidade}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Condutores no geral
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={condutoresGeral}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          motociclistas
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={motociclistas}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddVelocidade();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {/* Direção sob influência de álcool */}
            {usoAlcool && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Direção sob influência de álcool
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoAlcool}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoAlcool}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Positivos + Recusas
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={positivosRecusas}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Positivos
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={positivos}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddUsoAlcool();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {/* Uso do celular ao volante */}
            {usoCelular && add && (
              <CardContent className={classes.cardContent}>
                <Card className={classes.rootCardModal}>
                  <CardMedia className={classes.chartBar}>
                    <Typography className={classes.title}>
                      Uso do celular ao volante
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Container className={classes.containerFormControl}>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Mês/Ano
                        </Typography>
                        <InputMask mask="aaa/9999" inputRef={mesAnoCelular}>
                          {() => (
                            <input
                              type="text"
                              placeholder="mar/2018"
                              className={classes.selectField}
                              style={{ width: '100px' }}
                              required
                              ref={mesAnoCelular}
                            />
                          )}
                        </InputMask>
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Digitando
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={digitando}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                      <FormControl
                        margin="dense"
                        className={classes.formControl}
                        variant="outlined"
                      >
                        <Typography style={{ fontSize: '14px', marginBottom: '2%' }}>
                          Falando
                        </Typography>
                        <input
                          type="number"
                          className={classes.selectField}
                          ref={falando}
                          style={{ width: '100px' }}
                          required
                        />
                      </FormControl>
                    </Container>
                  </CardContent>
                </Card>
                <div
                  style={{
                    display: 'flex',
                    width: '95%',
                    justifyContent: 'space-around',
                  }}
                >
                  <Button
                    type="submit"
                    className={classes.cancelButton}
                    variant="outlined"
                    onClick={() => {
                      handleCloseModal();
                      handleSetFalse();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    className={classes.submitButton}
                    variant="outlined"
                    onClick={() => {
                      handleAddUsoCelular();
                      handleSetFalse();
                    }}
                  >
                    Enviar
                  </Button>
                </div>
              </CardContent>
            )}
            {/* Uso do dispositivo de retenção para crianças */}
            {usoDispRetCrianca && edit && (
              <CardContent className={classes.cardContent}>
                {usoDispRetCriancaList &&
                  usoDispRetCriancaList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Uso do dispositivo de retenção para crianças
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoDispRetCri}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoDispRetCri}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Crianças
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={crianca}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Crianças pequenas
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={criancaPeq}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoDispRetCri(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {velocidade && edit && (
              <CardContent className={classes.cardContent}>
                {velocidadeList &&
                  velocidadeList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Velocidade
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoVelocidade}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoVelocidade}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Condutores no geral
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={condutoresGeral}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Motociclistas
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={motociclistas}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutVelocidade(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoAlcool && edit && (
              <CardContent className={classes.cardContent}>
                {usoAlcoolList &&
                  usoAlcoolList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Direção sob influência do álcool
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoAlcool}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoAlcool}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Positivos + Recusas
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={positivosRecusas}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Positivos
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={positivos}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoAlcool(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoCelular && edit && (
              <CardContent className={classes.cardContent}>
                {usoCelularList &&
                  usoCelularList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <Card className={classes.rootCardModal} key={item.uuid}>
                            <CardMedia className={classes.chartBar}>
                              <Typography className={classes.title}>
                                Uso do celular ao volante
                              </Typography>
                            </CardMedia>
                            <CardContent>
                              <Container className={classes.containerFormControl}>
                                <div className={classes.formsDiv}>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Mês/Ano
                                    </Typography>
                                    <InputMask
                                      mask="aaa/9999"
                                      defaultValue={item.mes_ano}
                                      inputRef={mesAnoCelular}
                                    >
                                      {() => (
                                        <input
                                          type="text"
                                          defaultValue={item.mes_ano}
                                          placeholder="mar/2018"
                                          className={classes.selectField}
                                          style={{ width: '100px' }}
                                          required
                                          ref={mesAnoCelular}
                                        />
                                      )}
                                    </InputMask>
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Digitando
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line1}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={digitando}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <Typography
                                      style={{ fontSize: '14px', marginBottom: '2%' }}
                                    >
                                      Falando
                                    </Typography>
                                    <input
                                      type="number"
                                      defaultValue={item.line2}
                                      placeholder=""
                                      className={classes.selectField}
                                      ref={falando}
                                      style={{ width: '100px' }}
                                      required
                                    />
                                  </FormControl>
                                </div>
                              </Container>
                            </CardContent>
                          </Card>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handlePutUsoCelular(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Enviar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </CardContent>
            )}

            {usoDispRetCrianca && remove && (
              <>
                {usoDispRetCriancaList &&
                  usoDispRetCriancaList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveUsoDispRetCri(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {velocidade && remove && (
              <>
                {velocidadeList &&
                  velocidadeList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveVelocidade(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {usoAlcool && remove && (
              <>
                {usoAlcoolList &&
                  usoAlcoolList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveUsoAlcool(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}

            {usoCelular && remove && (
              <>
                {usoCelularList &&
                  usoCelularList.map((item) => {
                    if (item.uuid === anoKey) {
                      return (
                        <>
                          <img src={Remove} alt="Não foi possível importar." width="50" />
                          <Typography variant="h6">
                            Essa ação removerá o dado selecionado. Deseja continuar?
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              width: '95%',
                              justifyContent: 'space-around',
                            }}
                          >
                            <Button
                              type="submit"
                              className={classes.cancelButton}
                              variant="outlined"
                              onClick={() => {
                                handleCloseModal();
                                handleSetFalse();
                              }}
                            >
                              Cancelar
                            </Button>
                            <Button
                              type="submit"
                              className={classes.submitButton}
                              variant="outlined"
                              onClick={() => {
                                handleRemoveCelular(item.uuid);
                                handleSetFalse();
                              }}
                            >
                              Confirmar
                            </Button>
                          </div>
                        </>
                      );
                    }
                    return null;
                  })}
              </>
            )}
          </div>
        </Fade>
      </Modal>
    );
  };

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  if ((tecEng || geofi || publicGroup || typist) && !admin) {
    history.push('/mapa/sinistros');
  }
  return (
    <>
      {loading ? (
        <div className={classes.loadingContainer}>
          <CircularProgress className={classes.loadingSpinner} size={60} thickness={5} />
        </div>
      ) : (
        <>
          {panelStartDate &&
            panelEndDate &&
            mapStartDate &&
            panelEndDate &&
            generalDate &&
            fatalDate && (
              <>
                {openModal ? modal() : <></>}
                <Container maxWidth="xl" className={classes.root}>
                  <div className={classes.pageHeader}>
                    <Typography variant="h5" className={classes.pageTitle}>
                      Funções de Gerência
                    </Typography>
                    <Button
                      endIcon={<OpenInNew />}
                      onClick={() => window.open('/admin', '_blank')}
                      className={classes.openInNewBtn}
                    >
                      Gerenciar Usuários
                    </Button>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCardGroup}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCardDate}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Datas consolidadas do mapa
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    value={mapStartDate || null}
                                    onChange={(event) =>
                                      handleDateChange('mapStartDateSetter', event)
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    maxDate={Date.now()}
                                    format="dd/MM/yyyy"
                                    value={mapEndDate || null}
                                    onChange={(event) =>
                                      handleDateChange('mapEndDateSetter', event)
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                            </Container>
                          </CardContent>
                        </Card>
                        <Card className={classes.rootCardDate}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Datas consolidadas do painel
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    value={panelStartDate || null}
                                    onChange={(event) =>
                                      handleDateChange('panelStartDateSetter', event)
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    value={panelEndDate || null}
                                    onChange={(event) =>
                                      handleDateChange('panelEndDateSetter', event)
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                            </Container>
                          </CardContent>
                        </Card>

                        <Card className={classes.rootCardDate}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Datas consolidadas no resumo
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={6} style={{ textAlign: 'center' }}>
                                  <InputLabel style={{ fontWeight: 'bold' }}>
                                    Fatais
                                  </InputLabel>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <MuiPickersUtilsProvider
                                      locale={ptBR}
                                      utils={DateFnsUtils}
                                    >
                                      <KeyboardDatePicker
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        value={fatalDate || null}
                                        onChange={(event) =>
                                          handleDateChange('fatalDateSetter', event)
                                        }
                                        placeholder="dd/mm/aaaa"
                                        inputVariant="outlined"
                                        className={classes.datePicker}
                                        helperText=""
                                      />
                                    </MuiPickersUtilsProvider>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={6} style={{ textAlign: 'center' }}>
                                  <InputLabel style={{ fontWeight: 'bold' }}>
                                    Gerais
                                  </InputLabel>
                                  <FormControl
                                    margin="dense"
                                    className={classes.formControl}
                                    variant="outlined"
                                  >
                                    <MuiPickersUtilsProvider
                                      locale={ptBR}
                                      utils={DateFnsUtils}
                                    >
                                      <KeyboardDatePicker
                                        variant="inline"
                                        format="dd/MM/yyyy"
                                        value={generalDate || null}
                                        onChange={(event) =>
                                          handleDateChange('generalDateSetter', event)
                                        }
                                        placeholder="dd/mm/aaaa"
                                        inputVariant="outlined"
                                        className={classes.datePicker}
                                        helperText=""
                                      />
                                    </MuiPickersUtilsProvider>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </Container>
                          </CardContent>
                        </Card>

                        <Button
                          className={classes.submitButton}
                          variant="outlined"
                          onClick={() => postDate()}
                        >
                          Enviar
                        </Button>
                      </CardContent>
                    </Container>

                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Definir Metas
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {goal.map((item) => {
                                    return (
                                      <div key={item.uuid} className={classes.mapStyle}>
                                        <div className={classes.label}>
                                          <Typography variant="subtitle2">
                                            {item.related_year}
                                          </Typography>
                                        </div>
                                        <div className={classes.label}>
                                          <Typography variant="subtitle2">
                                            {item.goal_value}
                                          </Typography>
                                        </div>
                                        <Button
                                          onClick={() => {
                                            setOpenModal(true);
                                            setMeta(true);
                                            setEdit(true);
                                            setAnoKey(item.uuid);
                                          }}
                                          className={classes.edit}
                                          style={{ marginRight: '3%' }}
                                          variant="outlined"
                                        >
                                          Editar
                                        </Button>
                                        <Button
                                          className={classes.remove}
                                          variant="outlined"
                                          onClick={() => {
                                            setOpenModal(true);
                                            setMeta(true);
                                            setRemove(true);
                                            setAnoKey(item.uuid);
                                          }}
                                        >
                                          <img
                                            src={Remove}
                                            alt="Remover meta"
                                            width={25}
                                          />
                                        </Button>
                                      </div>
                                    );
                                  })}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setMeta(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              OMS 1
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {oms1List.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="body2">
                                          {value.year}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="body2">
                                          {value.qtdMortosPorQtdVeiculos.toFixed(2)}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="body2">
                                          {value.qtdMortosPorQtdMotos.toFixed(2)}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        variant="outlined"
                                        onClick={() => {
                                          setOpenModal(true);
                                          setOMS1(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setOMS1(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setOMS1(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              OMS 2
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {oms2List.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="body2">
                                          {value.year}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="body2">
                                          {value.qtdMortosPorPopulacao.toFixed(2)}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        onClick={() => {
                                          setOpenModal(true);
                                          setOMS2(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        variant="outlined"
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setOMS2(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setOMS2(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Uso do capacete
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoCapaceteList.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        variant="outlined"
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCapacete(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCapacete(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoCapacete(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>

                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Uso do cinto 1
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoCinto1List.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCinto1(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        variant="outlined"
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCinto1(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover dado" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoCinto1(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Uso do cinto 2
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoCinto2List.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCinto2(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        variant="outlined"
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCinto2(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover dado" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoCinto2(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>

                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Uso do dispositivo de retenção para crianças
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoDispRetCriancaList.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        variant="outlined"
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoDispRetCrianca(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoDispRetCrianca(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoDispRetCrianca(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Velocidade
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {velocidadeList.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        onClick={() => {
                                          setOpenModal(true);
                                          setVelocidade(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        variant="outlined"
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setVelocidade(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover dado" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setVelocidade(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>

                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Direção sob influência do álcool
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoAlcoolList.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        variant="outlined"
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoAlcool(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoAlcool(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoAlcool(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>
                  </div>

                  <div className={classes.groupContainer}>
                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCard}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Uso do celular ao volante
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <div className={classes.column}>
                                <div className={classes.columnChild}>
                                  {usoCelularList.map((value) => (
                                    <div key={value.uuid} className={classes.mapStyle}>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.mes_ano}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line1}
                                        </Typography>
                                      </div>
                                      <div className={classes.label}>
                                        <Typography variant="subtitle2">
                                          {value.line2}
                                        </Typography>
                                      </div>
                                      <Button
                                        className={classes.edit}
                                        variant="outlined"
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCelular(true);
                                          setEdit(true);
                                          setAnoKey(value.uuid);
                                        }}
                                      >
                                        Editar
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          setOpenModal(true);
                                          setUsoCelular(true);
                                          setRemove(true);
                                          setAnoKey(value.uuid);
                                        }}
                                        className={classes.remove}
                                        variant="outlined"
                                      >
                                        <img src={Remove} alt="Remover meta" width={25} />
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                                <Button
                                  onClick={() => {
                                    setOpenModal(true);
                                    setAdd(true);
                                    setUsoCelular(true);
                                  }}
                                  className={classes.add}
                                  variant="outlined"
                                >
                                  <img src={Add} alt="Adicionar novo" width={25} />
                                </Button>
                              </div>
                            </Container>
                          </CardContent>
                        </Card>
                      </CardContent>
                    </Container>

                    <Container className={classes.containerCard}>
                      <CardContent className={classes.cardContent}>
                        <Card className={classes.rootCardDate}>
                          <CardMedia className={classes.chartBar}>
                            <Typography
                              style={{ color: Colors.tertiary }}
                              className={classes.title}
                            >
                              Datas consolidadas do SAMU
                            </Typography>
                          </CardMedia>
                          <CardContent>
                            <Container className={classes.containerFormControl}>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    value={samuStartDate || null}
                                    onChange={(event) =>
                                      setSamuStartDate(
                                        toISOLocal(new Date(event as Date)),
                                      )
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                              <FormControl
                                margin="dense"
                                className={classes.formControl}
                                variant="outlined"
                              >
                                <MuiPickersUtilsProvider
                                  locale={ptBR}
                                  utils={DateFnsUtils}
                                >
                                  <KeyboardDatePicker
                                    variant="inline"
                                    maxDate={Date.now()}
                                    format="dd/MM/yyyy"
                                    value={samuEndDate || null}
                                    onChange={(event) =>
                                      setSamuEndDate(toISOLocal(new Date(event as Date)))
                                    }
                                    placeholder="dd/mm/aaaa"
                                    inputVariant="outlined"
                                    className={classes.datePicker}
                                    helperText=""
                                  />
                                </MuiPickersUtilsProvider>
                              </FormControl>
                            </Container>
                          </CardContent>
                        </Card>

                        <Button
                          className={classes.submitButton}
                          variant="outlined"
                          onClick={() => transferSamuToIncident()}
                        >
                          Enviar
                        </Button>
                      </CardContent>
                    </Container>
                  </div>
                </Container>
              </>
            )}
        </>
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openError}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openError}>
          <div className={classes.paper}>
            <img src={Remove} alt="Não foi possível realizar essa operação." width="50" />
            <p id="transition-modal-description">
              Não foi possível realizar essa operação.
            </p>
            <Button className={classes.button} onClick={() => handleCloseError()}>
              Ok
            </Button>
          </div>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openSuccess}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openSuccess}>
          <div className={classes.paper}>
            <img src={Success} alt="Operação realizada com sucesso." width="50" />
            <p id="transition-modal-description">Operação realizada com sucesso.</p>
            <Button className={classes.button} onClick={() => handleCloseSuccess()}>
              Ok
            </Button>
          </div>
        </Fade>
      </Modal>
      <ShowSnackbar
        open={snackBar.open}
        message={snackBar.message}
        setSnackbar={setSnackbar}
      />
    </>
  );
};

export default Management;
